module.exports = __webpack_public_path__ + "images/manifestum/fioleMediateurNumerique.ef3a6b9b.svg";